module.exports = __webpack_public_path__ + "img/medensy.72e64934.png";